import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Model, { onChange as onChangeModel } from '../../lib/Model'

import { H2, Form, Field, Input, Note, Button } from '../Common'

import style from './Form.scss'

class FormForgotPassword extends Component {
  static propTypes = {
    search: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  }

  state = {
    error: false,
    form: {
      submitted: false,
      loading: false,
      email: new Model('email', this.props.search.email, 'email'),
    },
  }

  onChange = (event, model) => {
    this.setState(onChangeModel(model))
  }

  handleSubmit = () => {
    const { submitted, email } = this.state.form
    if (submitted === false) {
      this.setState((state) => ({
        ...state,
        form: {
          ...state.form,
          submitted: true,
        },
      }))
    }

    if (this.props.loading || email.invalid) {
      return
    }

    this.props.onSubmit(
      {
        email: email.value,
      },
      (err) => {
        if (!err) return
        this.setState((state) => ({
          ...state,
          error: true,
        }))
      },
    )
  }

  render() {
    const { loading } = this.props
    const { error, form } = this.state
    const { submitted, email } = form
    const emailInvalid = submitted && email.untouched && email.invalid

    return (
      <div className={style.wrapper}>
        <H2 className={style.h2}>recuperar senha</H2>
        <Form id="form-esqueci-senha" onSubmit={this.handleSubmit} className={style.form}>
          <Field label="e-mail" className={style.field}>
            <Input
              id="email"
              model={email}
              invalid={emailInvalid}
              onChange={this.onChange}
              size="xl"
              required
              tabIndex={0}
              autoFocus
            />
            <Note id="email-obrigatorio" error show={emailInvalid}>
              campo obrigatório
            </Note>
            <Note id="msg-link-recuperacao">um link de recuperação será enviado para seu e-mail</Note>
          </Field>
          <Button id="submit-enviar" submit loading={loading} theme="greenDecide" xl>
            enviar
          </Button>
          <Note id="ocorreu-problema" error show={error && !loading}>
            ops! ocorreu um problema.
            <br />
            Por favor tente novamente em alguns minutos.
          </Note>
        </Form>
      </div>
    )
  }
}

export default FormForgotPassword



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/Form.js